import { importProjectAtomically } from "../persistence/artworkRepository";
import { createThumbnailBlob } from "../persistence/thumbnail";
import { LayerRasterStore } from "../layers/LayerRasterStore";
import { createCompositeCanvas } from "../layers/LayerCompositor";
import type { PerfectDrawProject } from "../projects/types";
import { assertAggregateRasterMemoryWithinBudget } from "../layers/layerMemory";
import {
  MAX_BACKUP_FILE_BYTES,
  createImportedProjectData,
  validateBackupText,
} from "./backupSchema";

export async function importProjectBackup(file: File): Promise<PerfectDrawProject> {
  if (file.size > MAX_BACKUP_FILE_BYTES) throw new Error("The backup file is too large.");
  const validated = validateBackupText(await file.text(), file.size);
  const { project, documentState, rasterLayers } = createImportedProjectData(validated);
  assertAggregateRasterMemoryWithinBudget(project.width, project.height, rasterLayers);
  const raster = new LayerRasterStore(
    { width: project.width, height: project.height },
    documentState.layers,
  );
  try {
    await raster.load(rasterLayers);
    const canvas = createCompositeCanvas(raster, documentState, {
      width: project.width,
      height: project.height,
    });
    const thumbnailBlob = await createThumbnailBlob(canvas);
    canvas.width = 1;
    canvas.height = 1;
    await importProjectAtomically(project, rasterLayers, thumbnailBlob, documentState);
    return { ...project, thumbnailBlob };
  } finally {
    raster.destroy();
  }
}
